import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { from, filter, tap } from 'rxjs'
import { handleMessages } from '../modules/client/utilities'

export default {
  state: () => ({
    marquee: null
  }),
  actions: {
    getMarquee(context, { config = {} } = { config: {} }) {
      const { rootState, commit } = context
      return from(
        this.$axios.$post(
          `/webapi/index/getNewAnnouncement`,
          {
            type: 'title',
            languageCode: rootState.locale
          },
          getAxiosConfig(arguments[0], config)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => commit('MARQUEE', data))
        )
        .toPromise()
    }
  },
  mutations: {
    MARQUEE(state, payload) {
      state.marquee = payload
    }
  },
  getters: {
    marquee(state) {
      return state.marquee
    }
  }
}
